/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useQuery } from 'react-query';
import { coreService } from 'network-utils';

export const getLearningPaths = 'learning-paths-data';
export const getUserLearningPath = 'user-learning-path';
export const getUserLanguages = 'user-languages';
export const getLearningPathOverview = 'learning-path-overview';

export const useGetLearningPaths = (token: string) => {
    return useQuery([getLearningPaths, token], () => coreService.learningPathApi.getLearningPaths(token), {
        enabled: !!token,
        keepPreviousData: true
    });
};

export const useGetUserLearningPath = (learningPathUuid: string | null, token: string) => {
    return useQuery(
        [getUserLearningPath, learningPathUuid, token],
        () => coreService.learningPathApi.getUserLearningPath(String(learningPathUuid), token),
        {
            enabled: !!learningPathUuid && !!token,
            keepPreviousData: true
        }
    );
};

export const useGetUserLanguages = (token: string) => {
    return useQuery([getUserLanguages, token], () => coreService.learningPathApi.getUserLanguages(token), {
        enabled: !!token,
        keepPreviousData: true
    });
};

export const useGetLearningPathOverview = (learningPathUuid: string, token: string) => {
    return useQuery(
        [getLearningPathOverview, token],
        () => coreService.learningPathApi.getLearningPathOverview(learningPathUuid, token),
        {
            enabled: !!token,
            keepPreviousData: true
        }
    );
};
